import { useState, useEffect } from 'react';

const BASE = 'https://releases.darkplanner.com.br/';
const YAML_URL = BASE + 'latest.yml';
// .bat só como ÚLTIMO recurso (se o yml estiver inacessível/ilegível).
const BAT_FALLBACK = BASE + 'DarkPlanner-Installer.bat';
const FALLBACK_VERSION = '0.3.0';

export function useWindowsReleaseInfo() {
  const [info, setInfo] = useState({
    version: FALLBACK_VERSION,
    downloadUrl: BAT_FALLBACK,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    fetch(YAML_URL, { signal: controller.signal })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((text) => {
        const version = text.match(/^version:\s*(.+)$/m)?.[1]?.trim() || FALLBACK_VERSION;
        // Aponta DIRETO para o .exe da release: usa o campo `path` do yml
        // (ex.: DarkPlanner-Setup-1.0.46.exe); se faltar, monta pelo padrão
        // DarkPlanner-Setup-<versao>.exe. .bat só se nada disso existir.
        const pathFile = text.match(/^path:\s*(.+)$/m)?.[1]?.trim().replace(/^['"]|['"]$/g, '');
        const file = pathFile || (version !== FALLBACK_VERSION ? `DarkPlanner-Setup-${version}.exe` : null);

        setInfo({
          version,
          downloadUrl: file ? BASE + file : BAT_FALLBACK,
          loading: false,
          error: null,
        });
      })
      .catch((err) => {
        console.warn('[DarkPlannerApp] Windows: fallback para .bat:', err.message);
        setInfo({
          version: FALLBACK_VERSION,
          downloadUrl: BAT_FALLBACK,
          loading: false,
          error: err.message,
        });
      })
      .finally(() => clearTimeout(timeoutId));

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, []);

  return info;
}
